import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ReactJson from '@lambdatestincprivate/react-json-view';
import LTCopyToClipboard from '../LTCopyToClipboard/index.js';
import { themeGet } from '@primer/react';
import { JsonTheme } from '../../utils/jsonTheme.js';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var DataWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  &:focus-visible {\n    outline-color: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  &:focus-visible {\n    outline-color: ", ";\n  }\n"])), themeGet("colors.focus.outlineColor"));
var DataRowWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-bottom: none;\n  display: flex;\n  font-size: 12px;\n\n  &:last-child {\n    border-bottom: 1px solid ", ";\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n  &:first-child {\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n  }\n  @media only screen and (max-width: 1024px) {\n    display: flex;\n    flex-direction: column;\n  }\n"], ["\n  border: 1px solid ", ";\n  border-bottom: none;\n  display: flex;\n  font-size: 12px;\n\n  &:last-child {\n    border-bottom: 1px solid ", ";\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n  &:first-child {\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n  }\n  @media only screen and (max-width: 1024px) {\n    display: flex;\n    flex-direction: column;\n  }\n"])), themeGet("colors.border.default"), themeGet("colors.border.default"));
var KeyWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-right: 1px solid ", ";\n  font-weight: 600;\n  flex-shrink: 0;\n  line-height: 28px;\n  padding: 6px 12px;\n  min-width: 100px;\n  text-transform: capitalize;\n  @media only screen and (max-width: 1024px) {\n    border: none;\n  }\n  @media only screen and (max-width: 320px) {\n    max-width: 100%;\n  }\n"], ["\n  border-right: 1px solid ", ";\n  font-weight: 600;\n  flex-shrink: 0;\n  line-height: 28px;\n  padding: 6px 12px;\n  min-width: 100px;\n  text-transform: capitalize;\n  @media only screen and (max-width: 1024px) {\n    border: none;\n  }\n  @media only screen and (max-width: 320px) {\n    max-width: 100%;\n  }\n"])), themeGet("colors.border.default"));
var CopyWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-self: start;\n  margin-left: 5px;\n  visibility: hidden;\n"], ["\n  align-self: start;\n  margin-left: 5px;\n  visibility: hidden;\n"])));
var ValueWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  padding: 6px 12px;\n  word-break: break-all;\n\n  &:hover ", " {\n    visibility: visible;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  padding: 6px 12px;\n  word-break: break-all;\n\n  &:hover ", " {\n    visibility: visible;\n  }\n"])), CopyWrapper);
/**
 * Table component.
 * @param {!Object<string, *>} data The data to render in tabular format.
 */
var LTTable = function LTTable(_a) {
  var _b = _a.allowValueCopy,
    allowValueCopy = _b === void 0 ? false : _b,
    _c = _a.columns,
    columns = _c === void 0 ? [] : _c,
    _d = _a.data,
    data = _d === void 0 ? {} : _d,
    _e = _a.tabIndex,
    tabIndex = _e === void 0 ? -1 : _e;
  var _f = useState("auto"),
    firstColumnWidth = _f[0],
    setFirstColumnWidth = _f[1];
  var dataKeys = data ? Object.keys(data) : [];
  var _g = (JsonTheme || {}).light,
    lightJsonTheme = _g === void 0 ? {} : _g;
  var getFirstColumnWidth = function getFirstColumnWidth(dataKeys) {
    // Calculate the maximum width based on the values in the first column
    var maxWidth = Math.max.apply(Math, dataKeys.map(function (key) {
      return key.length * 10;
    }));
    setFirstColumnWidth("".concat(maxWidth, "px"));
  };
  useEffect(function () {
    getFirstColumnWidth(dataKeys);
  }, [dataKeys]);
  if (dataKeys.length === 0) {
    return /*#__PURE__*/React.createElement(DataWrapper, null, /*#__PURE__*/React.createElement(DataRowWrapper, null, /*#__PURE__*/React.createElement(ValueWrapper, {
      style: {
        textAlign: "center",
        width: "100%"
      }
    }, "No data available")));
  }
  return /*#__PURE__*/React.createElement(DataWrapper, {
    role: "table",
    tabIndex: tabIndex
  }, columns && columns.length > 0 && /*#__PURE__*/React.createElement("div", {
    role: "rowgroup"
  }, /*#__PURE__*/React.createElement(DataRowWrapper, {
    role: "row",
    style: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      fontWeight: 600,
      fontSize: "14px"
    }
  }, columns.map(function (key, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 ? /*#__PURE__*/React.createElement(KeyWrapper, {
      role: "columnheader",
      style: {
        width: firstColumnWidth
      }
    }, key) : /*#__PURE__*/React.createElement(ValueWrapper, {
      role: "columnheader"
    }, key));
  }))), /*#__PURE__*/React.createElement("div", {
    role: "rowgroup"
  }, dataKeys.map(function (key, index) {
    var value = data[key];
    var textToCopy = value;
    if (_typeof(value) === "object") {
      textToCopy = JSON.stringify(value, undefined, 2);
    }
    return /*#__PURE__*/React.createElement(DataRowWrapper, {
      style: {
        background: index % 2 === 0 ? "#fff" : "#F6F8FA",
        borderTopLeftRadius: index === 0 && columns.length > 0 ? 0 : "",
        borderTopRightRadius: index === 0 && columns.length > 0 ? 0 : "",
        borderTop: index === 0 && columns.length > 0 ? "none" : ""
      },
      key: "".concat(key, "-").concat(index),
      role: "row"
    }, /*#__PURE__*/React.createElement(KeyWrapper, {
      style: {
        width: firstColumnWidth
      },
      role: "cell"
    }, key), /*#__PURE__*/React.createElement(ValueWrapper, {
      role: "cell"
    }, !!value && _typeof(value) === "object" ? /*#__PURE__*/React.createElement(ReactJson, {
      displayDataTypes: false,
      displayObjectSize: false,
      enableClipboard: false,
      name: false,
      src: value,
      theme: lightJsonTheme
    }) : "".concat(value || "-"), allowValueCopy && value && /*#__PURE__*/React.createElement(CopyWrapper, null, /*#__PURE__*/React.createElement(LTCopyToClipboard, {
      textToCopy: textToCopy
    }))));
  })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { LTTable as default };
